
<app-header></app-header>
<app-right-side></app-right-side>

<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.5.0/font/bootstrap-icons.css">
<!-- <div class="header-spacer header-spacer-small"></div> -->

<!-- Main Header Weather -->

<div class="main-header main-header-weather">
    <div class="content-bg-wrap bg-weather"></div>

    <div class="date-and-place" style=" padding-left:50px; margin: 0px auto; top:100%; background-color: var(--background-color); color: var(--text-color);"><br>
        <div class="date" style=" background-color: var(--background-color); color: var(--text-color); font-size: 15px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">Last Update : <i class="bi bi-calendar3"></i>&nbsp;{{today | date: 'fullDate'}} - {{today | date: 'mediumTime'}}</div>
        <!-- <div class="place">{{currentUser.success.user.countryName}}</div> -->
    </div>

    <div class="wethear-update">
        
        <svg class="olymp-weather-refresh-icon">
			<use xlink:href="../../../assets/svg-icons/sprites/icons.svg#olymp-weather-refresh-icon"></use>
		</svg>
    </div>
    <div class="container">
        <div class="row">
            <div class="m-auto col-lg-4 col-md-8 col-sm-12 col-12">
                <div class='wrapper'>
                <div class='panel' style="text-align: center;">
                    <h2 class='city' id='city' style="text-align: center;"></h2>
                    <div class='weather' id='weather'>
                      <div class='temperature' id='temperature'>
                        <h1 class='temp' id='temp'><i id='condition'></i> <span id='num'></span></h1>
                      </div>
                    </div>
                  </div></div>
            </div>
        </div>
    </div>

    <img class="img-bottom" src="../../../assets/img/weather-bottom.png" alt="friends">
</div>

<!-- ... end Main Header Weather -->



<!-- Widget Weather -->
<br>
<div class="container1">
    <div class="row">
        <div class="col col-xl-12 order-xl-12 col-lg-12 order-lg-2 col-md-12 col-sm-12 col-12">
            <div class="ui-block" style="background-color: #50acd6;">
                <div class='wrapper'>

                    <div id="search1">
                      <form>
                        <div class="container1">
                          <div class="row">
                            <div class="col-lg-3 col-3"><input class='searchbar transparent' id='search' type='text' placeholder='enter city, country' /></div>
                            <div class="col-lg-1 col-8"><input class='btn' id='button' type="submit" value='GO' style="background-color: chocolate;" /></div>
                          </div>
                        </div>
                        
                        
                      </form>
                    </div>
                  
                    <div class='panel'>
                      <h2 class='city' id='city'></h2>
                      <div class='weather' id='weather'>
                        <div class='group secondary' style="text-align: left; width: 350px;">
                          <h3 id='dt'></h3>
                          <h3 id='description'></h3>
                        </div>
                        <div class='group secondary' style="text-align: left; width: 350px;">
                          <h3 id='wind'></h3>
                          <h3 id='humidity'></h3>
                        </div>
                        <div class='temperature' id='temperature'>
                          <h1 class='temp' id='temp'><i id='condition'></i> <span id='num'></span><a class='fahrenheit active' id='fahrenheit'>&deg;F</a><span class='divider secondary'>|</span><a class='celsius' id='celsius'>&deg;C</a></h1>
                        </div>
                        <br><br>
                        <div class="container">
                            <div class="row">
                                <div class='forecast' id='forecast'></div>
                            </div>
                        </div>
                        
                      </div>
                    </div>
            </div>
        </div>
    </div>
</div>

<!-- ... end Widget Weather -->